import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Image, List, Modal, Pagination, Table} from "antd";
import {useStore} from "../../store";
import LibraryDetail from "../plant-library/library-detail";
import {ImageInfoEntity} from "../../entity/image-info-entity";
import {BaseImageUrl} from "../../http/http";

const SearchGlobalLibrary:React.FC = () => {
    const {searchGlobal} = useStore();

    const onSizeChange = (page: any, pageSize: any) => {
        searchGlobal.queryGlobal("2", page)
    }

    const onClose = () => {
        searchGlobal.setLibraryDetailModal(false)
    }

    const toDetail = (item: ImageInfoEntity, index: number) => {
        searchGlobal.setLibraryDetailEntity(item)
        searchGlobal.setLibraryDetailModal(true)
    }
    const renderItem = (item: ImageInfoEntity, index: number) => {
        return <List.Item style={{minWidth: "400px"}}>
            <CardWrapper onClick={() => toDetail(item, index)}>
                <div style={{display: "flex", flexDirection: "row", padding: "5px 20px 10px 5px"}}>
                    <Image style={{width:"150px", height:"150px", margin:"15px 20px 10px 15px"}} src={BaseImageUrl+item.imgUrl} preview={false}/>
                    <CardContent>
                        <span>{`物种名:${item.cnName}`}</span>
                        <span>{`物种拉丁名：${item.ldName}`}</span>
                        <span>{`科名：${item.specCnName}`}</span>
                        <span>{`种拉丁名：${item.genLdName}`}</span>
                        <span>{`拍摄时间：${item.createtime}`}</span>
                    </CardContent>
                </div>
            </CardWrapper>
        </List.Item>
    }

    return (<Wrapper>
        <ContentWrapper>
            <div
                style={{
                    // margin: "15px 79px",
                    padding: "10px 0",
                    minHeight: "200px",
                    overflowY: "auto",
                    overflowX: "hidden"
                }}>
                <List grid={{
                    gutter: 16,
                    column: 3
                }} style={{overflow: "scroll"}} dataSource={searchGlobal.libraryDataSource} renderItem={renderItem}/>
            </div>
            <Pagination
                size={"small"}
                style={{margin: "0 20px 20px 0", alignSelf: "end"}}
                total={searchGlobal.libraryPagination.total}
                showQuickJumper={true}
                showSizeChanger={true}
                defaultPageSize={10}
                hideOnSinglePage={true}
                onChange={onSizeChange}
                current={searchGlobal.libraryPagination.pageNum}
            />
        </ContentWrapper>
        <Modal
            open={searchGlobal.libraryDetailModalOpen}
            onCancel={onClose}
            closable={true}
            centered={true}
            destroyOnClose={true}
            title={null}
            footer={null}
            mask={true}
            maskClosable={true}
            width={"1000px"}>
            <LibraryDetail detail={searchGlobal.libraryDetail} index={0}/>
        </Modal>
    </Wrapper>);
}
export default observer(SearchGlobalLibrary);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    .ant-table-wrapper .ant-table-thead >tr>th {
      background: #EFF3F8 ;
    }
    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 20px 20px 20px 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;

    .ant-list {
      overflow-x: hidden;
    }
  }
`;
const CardWrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E8EBF2;
    border-radius: 2px;
  }
`;

const CardContent = styled.span`
  & {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;

    span:nth-child(1) {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: black;
      margin-bottom: 10px;
    }
  }
`;
